export class QueryParams {
  static getQueryParams() {
    return new URLSearchParams(window.location.search);
  }

  static getFriendTab = () => {
    return QueryParams.getQueryParams().get("friendTab") || "";
  };
}
